import React, {useEffect, useCallback, useState} from 'react'
import { useNavigate } from "react-router-dom";
import { getUnatHolders } from '../../util/api'
import { debounce } from 'lodash';
import { 
  Spinner,
  IconButton,
  Typography,
  Input,
  Progress,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Radio
} from '@material-tailwind/react';
import { formatUnixTime } from '../../util/format-data';
import { v4 as uuidv4 } from 'uuid';
import { formatAddress } from '../../util/format-data';
import Dust20IndexerDetail from './Dust20IndexerDetail';
import { getDust20Indexer } from '../../util/dust20-api';
import { useTranslation } from 'react-i18next';
import { formatFloat } from '../../util/format-data';
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { getAlkanesTopMint } from '../../util/alkanes-api';
import { formatNumberWithCommas } from '../../util/format-data';

export default function Dust20Indexer() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [ticker, setTicker] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState(1); // 0: id, 1: progress
  const [direct, setDirect] = useState(1); // 0: ASC, 1: DESC
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [detailticker, setDetailTicker] = useState('');
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetchTokenData(ticker, page);
  }, [page, sort, direct, active])

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const doublePrev = () => {
    setPage(1);
  }

  const doubleNext = () => {
    setPage(total);
  }

  const handleKeyChange = (e) => {
    setTicker(e.target.value)
    debouncedSearch(e.target.value)
  }

  const handleOrder = (value) => {
    setSort(value);
    setDirect(1 - direct);
  }

  const debouncedSearch = useCallback(debounce( async (value) => {
    try {
      await fetchTokenData(value, 1);
      setPage(1);
    }
    catch (e) {
      console.log(e);
    }
  }, 300), []); 

  const fetchTokenData = async (value, page) => {
    setLoading(true);
    let tempOrder = "";

    if (sort == 0) tempOrder = "id";
    else tempOrder = "progress";

    if (direct == 0) tempOrder += "Asc";
    else tempOrder += "Desc";

    let param = {
      query: value,
      page: page,
      limit: limit,
      order: tempOrder,
      active: active
    }
    let data = await getAlkanesTopMint(param);

    setDatas(data.data.records);
    setTotal(Math.ceil(data.data.total / limit));
    setLoading(false);
  }

  const showDetailIndexer = (value) => {
    setDetailTicker(value);
    setShowDetail(true);
  }
  return (
    <div className="bg-background3 rounded-lg text-white w-full max-w-[1500px] p-3 flex flex-col justify-center items-center mt-8">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      {
        showDetail ? <Dust20IndexerDetail ticker = {detailticker} handleShowDetail = {setShowDetail} setLoading = {setLoading}/> : 
        <>
          {
            <div className="flex flex-col gap-2 w-full">
              { 
                <div className="flex flex-row w-full justify-between items-center mt-3">
                  {/* <div className="md:flex hidden font-bold text-primary text-[20px]">
                    {active == null ? t('ALL') : active == 1 ? t('In-Progress') : t('Completed')} ALKANES
                  </div> */}
                  <div className="md:flex hidden font-bold text-primary text-[20px]">
                    <Radio 
                      name="type" 
                      color="pink" 
                      checked={active == null}
                      onChange={() => setActive(null)}
                      className={`${active == null ? 'border-primary' : 'border-white'}`}
                      label={
                        <Typography
                        className={`flex font-medium  ${active == null ? 'text-primary' : 'text-white'}`}
                        >
                          {t('ALL')}
                        </Typography>
                      } 
                    />
                    <Radio 
                      name="type" 
                      color="pink" 
                      checked={active == 1}
                      onChange={() => setActive(1)}
                      className={`${active == 1 ? 'border-primary' : 'border-white'}`}
                      label={
                        <Typography
                        className={`flex font-medium  ${active == 1 ? 'text-primary' : 'text-white'}`}
                        >
                          {t('In-Progress')}
                        </Typography>
                      } 
                      defaultChecked 
                    />
                    <Radio 
                      name="type" 
                      color="pink" 
                      checked={active == 0}
                      onChange={() => setActive(0)}
                      className={`${active == 0 ? 'border-primary' : 'border-white'}`}
                      label={
                        <Typography
                          className={`flex font-medium  ${active == 0 ? 'text-primary' : 'text-white'}`}
                        >
                          {t('Completed')}
                        </Typography>
                      } 
                    />
                  </div>
                  <div className="flex flex-row max-w-[500px] w-full justify-end gap-2">
                    <div>
                      <Input type="text" color="white" label = {t('Search By ID or Name')} className="w-[250px]" value = {ticker} onChange = {(e) => {handleKeyChange(e)}}/>
                    </div>

                    <div className="md:hidden block">
                      <Menu placement="bottom-end">
                        <MenuHandler>
                          <IconButton
                            size="md"
                            variant="outlined"
                            className="border-primary border-[2px]"
                          >
                            <FunnelIcon strokeWidth={2} className="h-7 w-7 text-primary" />
                          </IconButton>
                        </MenuHandler>
                        <MenuList className="bg-black border-black text-white">
                          <MenuItem onClick={() => setActive(null)}>{t('ALL')}</MenuItem>
                          <MenuItem onClick={() => setActive(1)}>{t('In-Progress')}</MenuItem>
                          <MenuItem onClick={() => setActive(0)}>{t('Completed')}</MenuItem>
                        </MenuList>
                      </Menu>
                    </div>
                  </div>
                </div>
              }
              <div className="flex flex-row px-4 py-2 items-center">
                <div className = "md:w-[8%] md:flex hidden"></div>
                <div className = "md:w-[8%] w-[20%] flex flex-row gap-1 items-center">
                  <span>{t('ID')}</span>
                  <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(0)}>
                    <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 0 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                    <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 0 && direct == 0 ? 'text-primary' : 'text-white'}`} />
                  </div>
                </div>
                <div className = "md:w-[12%] w-[35%] flex-row items-center gap-1">
                  <span>{t('Name')}</span>
                </div>
                <div className = "md:w-[10%] md:block hidden">{t('Symbol')}</div>
                <div className = "md:w-[18%] md:block hidden">{t('Per Mint')}</div>
                <div className = "md:w-[18%] md:flex flex-row gap-1 items-center hidden">
                  <span>{t('Max Supply')}</span>
                </div>
                <div className = "md:w-[18%] w-[30%] flex flex-row gap-1 items-center justify-center">
                  <span>{t('Progress')}</span>
                  <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(1)}>
                    <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 1 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                    <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 1 && direct == 0 ? 'text-primary' : 'text-white'}`} />
                  </div>
                </div>
                <div className = "md:w-[8%] w-[15%] text-center">{t('Action')}</div>
              </div>
              {
                datas.map((data) => 
                  <div 
                    className="flex flex-row gap-1 items-center text-white bg-gray-900 p-4 rounded-lg cursor-pointer" 
                    key={uuidv4()}
                  >
                    <div className = "md:w-[8%] md:flex hidden">
                      <img src={data.image} className="w-[50px] h-[50px] rounded-md"/>
                    </div>
                    <div className = "md:w-[8%] w-[20%] flex flex-row gap-1 items-center">
                      <span>{data.id}</span>
                    </div>
                    <div className = "md:w-[12%] w-[35%] flex-row items-center gap-1">
                      <span>{data.name}</span>
                    </div>
                    <div className = "md:w-[10%] md:block hidden">{data.symbol}</div>
                    <div className = "md:w-[18%] md:block hidden">{formatNumberWithCommas(data.mintAmount / Math.pow(10, 8))}</div>
                    <div className = "md:w-[18%] md:flex flex-row gap-1 items-center hidden">
                      <span>{formatNumberWithCommas(data.totalSupply / Math.pow(10, 8))}</span>
                    </div>
                    <div className = "md:w-[18%] w-[30%] gap-1 items-center flex flex-col">
                      <div className="text-blue-800">
                        {data.progress}%
                      </div>
                      <div className="md:w-[105px] w-[80px]">
                        <Progress  value={data.progress} color="blue" size="sm" />
                      </div>   
                    </div>
                    <div className = "md:w-[8%] w-[15%] text-center">
                      {
                        data.progress == 100 || data.id.trim() == "2:0" ? 
                        <></>:
                        <div className="md:py-2 md:px-4 py-1 px-1 text-white rounded-md font-bold bg-primary cursor-pointer hover:bg-primary-hover" onClick={() => {navigate(`/alkanes/mint/${data.id}`)}}>{t('MINT')}</div>
                      }
                    </div>
                  </div>
                )
              }
            </div> 
          }
          {
            total > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doublePrev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={prev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={next}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doubleNext}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
            :
            <></>
          }
        </>
      }
      
    </div>
  )
}
